import React, { useRef } from 'react';

const UploadButton = ({ onFileUpload }) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Trigger the hidden file input
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log('Selected file:', file);
    if (file) {
      onFileUpload(file); // Pass the file to the parent component or handler
    }
  };

  return (
    <div>
      <button className='btn btn-primary ml-2' onClick={handleButtonClick} style={{ cursor: 'pointer' }}>
        Upload File 
      </button>
      <input
        type="file"
        ref={fileInputRef}
        accept=".xlsx, .csv" 
        style={{ display: 'none' }} // Hide the input box
        onChange={handleFileChange}
      />
    </div>
  );
};

export default UploadButton;